<template>
  <div>
    <div style="margin-top: 20px">
      <el-button size="mini" type="primary" @click="printerAdd" style="margin-bottom: 10px">{{$t('lang.Button.Add')}}</el-button>
    </div>
    <el-table 
      height="650"
      :data="printerList"
      :row-key="getKey"
      border strip
      size="mini" 
      :header-cell-style="{background:'#e4f1ff'}"
      @sort-change="sortMethos"
      >
      <el-table-column
        :reserve-selection="true"
        :selectable="checkboxInit"
        type="selection"
        min-width="40">
      </el-table-column>
      <el-table-column :label="$t('lang.PrinterDriver.printDrive')" prop="printDrive" sortable="custom" min-width="120px">
        <template slot-scope="scope">
          <el-input v-if="scope.$index==0" :placeholder="$t('lang.PrinterDriver.printDriveSearch')"  v-model="params.pdrive" size="mini" clearable style="width: 200px"></el-input>
          <span class="fontStyle" v-else>{{scope.row.printDrive}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.PrinterDriver.printType')" prop="printType" sortable="custom">
        <template slot-scope="scope">
          <el-input v-if="scope.$index==0" :placeholder="$t('lang.PrinterDriver.printTypeSearch')" v-model="params.ptype" size="mini" clearable style="width: 200px"></el-input>
          <span class="fontStyle" v-else>{{scope.row.printType}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.PrinterDriver.driveSign')" prop="tag" sortable="custom" align="center">
        <template slot-scope="scope">
          <el-select v-if="scope.$index==0" v-model="params.tag" size="mini" :placeholder="$t('lang.PrinterDriver.driveSign')" clearable>
            <el-option :label="$t('lang.PrinterDriver.common')" :value="0"></el-option>
            <el-option :label="$t('lang.PrinterDriver.special')" :value="1"></el-option>
          </el-select>
          <div v-else>
            <el-tag v-if="scope.row.tag == 0" type="success">{{$t('lang.PrinterDriver.common')}}</el-tag>
            <el-tag v-else-if="scope.row.tag == 1" type="danger">{{$t('lang.PrinterDriver.special')}}</el-tag>
            <!-- <span v-if="scope.row.tag == 0" class="fontStyle">普通</span>
            <span v-else-if="scope.row.tag == 1" class="fontStyle">特殊</span> -->
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.PrinterDriver.debugFlag')" prop="dsymbol" sortable="custom" align="center" width="130px">
        <template slot-scope="scope">
          <el-select v-if="scope.$index==0" v-model="params.dsymbol" size="mini" :placeholder="$t('lang.PrinterDriver.debugFlag')" clearable>
            <el-option :label="$t('lang.PrinterDriver.notDebugging')" :value="0"></el-option>
            <el-option :label="$t('lang.PrinterDriver.debuggingThrough')" :value="1"></el-option>
            <el-option :label="$t('lang.PrinterDriver.debuggingFailed')" :value="2"></el-option>
          </el-select>
          <div v-else>
            <!-- 0：未调试，1：通过，2：未通过 -->
            <!-- <div v-if="scope.row.dsymbol == 0">
              <span v-if="scope.row.dsymbol == 0" class="badge-status-badge-warning"></span>
              <span class="fontStyle" style="margin-left:10px">未调试</span>
            </div> -->
            <span v-if="scope.row.dsymbol == 0" class="badge-status-badge-warning"></span>
            <span v-else-if="scope.row.dsymbol == 1" class="badge-status-badge-status"></span>
            <span v-else-if="scope.row.dsymbol == 2" class="badge-status-badge-error"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.PrinterDriver.remark')" prop="remark">
        <template slot-scope="scope">
          <span class="fontStyle">{{scope.row.remark}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.TableComponent.operating')" align="center">
        <template slot-scope="scope">
          <el-button circle icon="el-icon-edit" v-if="scope.$index !==0" type="primary" @click="printerEdit(scope.row)"></el-button>
          <el-button circle icon="el-icon-delete" v-if="scope.$index !==0" type="danger" @click="printerDelete(scope.row.id)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="con">
      <el-pagination
        :total="pageParams.total"
        layout="total,sizes, prev, pager, next, jumper"
        :page-sizes="[10,25,50,100]"
        :page-size="pageParams.size"
        :current-page="pageParams.current"
        @size-change="sizeChange"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
    <cont-dialog ref="contDialog" @update="getList"></cont-dialog>
  </div>
</template>
<script>
import { queryPrinterList, deletePrinter, addPrinter, editPrinter } from '@/api/printer'
import contDialog from './component/contDialog'
import { cloneDeep } from 'lodash'
export default {
  name: 'PrinterDriver',
  components: {
    contDialog
  },
  data() {
    return {
      printerList: [],
      params: {
        offset: 1, // 当前页
        limit: 10, // 页最大数量
        ptype: '', // 打印机型号
        pdrive: '',// 打印驱动
        tag: '', // 驱动标志
        dsymbol: '',
        seq: '',
      },
      pageParams: {
        total: 0,
        size: 10,
        current: 1
      },
      paramsCopy: {}
    }
  },
  mounted() {
    this.getList()
  },
  watch: {
    'params.ptype': {
      // immediate: true,
      handler: function(ptype) {
        // 设置页码为第一页
        this.params.offset = 1
        this.getList()
      }
    },
    'params.pdrive':{
      // immediate: true,
      handler: function(pdrive) {
        // 设置页码为第一页
        this.params.offset = 1
        this.getList()
      }
    },
    'params.tag': {
      handler: function() {
        this.params.offset = 1
        this.getList()
      }
    },
    'params.dsymbol': {
      handler: function() {
        this.params.offset = 1
        this.getList()
      }
    }
  },
  methods: {
    // getKey 配合reserve-selection使用，在表格翻页数据刷新时记住上一页的勾选
    getKey(key) {
      return key.id
    },
    // 禁止表格第一行勾选
    checkboxInit(row, index) {
      if (index == 0) {
        return 0;
      } else {
        return 1;
      }
    },
    handleData() {
      this.paramsCopy = cloneDeep(this.params)
      this.paramsCopy.ptype = this.paramsCopy.ptype ? this.paramsCopy.ptype : undefined
      this.paramsCopy.pdrive = this.paramsCopy.pdrive ? this.paramsCopy.pdrive : undefined
      this.paramsCopy.seq = this.paramsCopy.seq ? this.paramsCopy.seq : undefined
      this.paramsCopy.tag = this.paramsCopy.tag !== '' ? this.paramsCopy.tag : undefined
    },
    // 获取全部打印机
    getList() {
      this.handleData()
      queryPrinterList(this.paramsCopy).then(res =>{
        if(res.data.code === 0) {
          let data = res.data.data
          if(data.list.length === 0 && data.offset > 1) {
            this.params.offset = data.offset - 1
            this.getList()
          }else{
            this.printerList = data.list || []
            this.pageParams.total = data.total
            this.pageParams.current = data.offset
            this.pageParams.size = data.size
            this.printerList.unshift({})
          }
        }else{
          res.message && this.$message.error(res.message)
        }
      }).catch(() =>{
      })
    },
    printerEdit(row) {
      this.$refs.contDialog.show(row)
    },
    printerDelete(id) {
      this.$confirm(this.$t('lang.Button.isDelete'), this.$t('lang.Button.tips'), {
        confirmButtonText: this.$t('lang.Button.confirm'),
        cancelButtonText: this.$t('lang.Button.cancel'),
        center: true,
        type: 'warning'
      }).then(res => {
        let data = {
          id: id
        }
        deletePrinter(data).then(res => {
          if(res.data.code === 0) {
            this.$message.success(this.$t('lang.Button.successDelete'))
            // this.params.offset = 1
            this.getList()
          }else{
            res.data.error_message && this.$message.error(res.data.error_message)
          }
        })
      }).catch(() =>{
      })
    },
    printerAdd() {
      this.$refs.contDialog.show()
    },
    // 每页条数发生变化
    sizeChange(size) {
      this.params.limit = size
      this.getList()
    },
    // 页码发生变化
    currentChange(current) {      
      this.params.offset = current 
      this.getList()
    },
    // 排序
    sortMethos(colunm) {
      let prop = colunm.prop
      if(colunm.order === 'descending') {
          if(prop === 'printDrive') {
            this.params.seq = 4
          }else if(prop === 'printType'){
            this.params.seq = 2
          }else if(prop === 'tag'){
            this.params.seq = 6
          }else if(prop === 'dsymbol'){
            this.params.seq = 8
          }
      }else {
        if(prop === 'printDrive') {
            this.params.seq = 3
          }else if(prop === 'printType'){
            this.params.seq = 1
          }else if(prop === 'tag'){
            this.params.seq = 5
          }else if(prop === 'dsymbol'){
            this.params.seq = 7
          }
      }
      this.params.offset = 1
      this.getList()
    }
  }
}
</script>
<style scoped>
.con {
  text-align: center;
  margin-top: 0.4rem;
}
.fontStyle{
  font-size: 0.25rem;
  height: 41px;
}
.badge-status-badge-status{
  width: 10px;
  height: 10px;
  background-color: #67c23a;
  position: relative;
  top: -1px;
  display: inline-block;
  vertical-align: middle;
  border-radius: 50%;
}
.badge-status-badge-warning{
  width: 10px;
  height: 10px;
  background-color: #e6a23c;
  position: relative;
  top: -1px;
  display: inline-block;
  vertical-align: middle;
  border-radius: 50%;
}
.badge-status-badge-error{
  width: 10px;
  height: 10px;
  background-color: #f56c6c;
  position: relative;
  top: -1px;
  display: inline-block;
  vertical-align: middle;
  border-radius: 50%;
}
</style>
  
